//import { RoundValueASTM } from './FuelMath';
import {Math} from './Math'
import {MathFormula} from './Math'
import { RoundValueASTM } from './FuelMath';

export default class TemperatureConversionService{
    static response={
        ConvertedTemperature:"",
        ConvertedTemperatureUnit:""
     };
     static CalculateTemperatureConversion(temperature,unit){
         ;
        switch(unit){
            case "celcius":
            let  celcius=(((9 / 5) * temperature) + 32);
            celcius=RoundValueASTM(celcius,0.01)
            return celcius;
            case "fahrenheit":
            let  fahrenheit=((temperature - 32) * (5 / 9));
            fahrenheit=RoundValueASTM(fahrenheit,0.01)
            return fahrenheit;
        }
         
     }
}